import { render, staticRenderFns } from "./ImportCommission.vue?vue&type=template&id=150e821a&"
import script from "./ImportCommission.vue?vue&type=script&lang=js&"
export * from "./ImportCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports